export enum RegionalLocales {
  SpanishSpain = 'es-es',
  FrenchFrance = 'fr-fr',
  FrenchCanada = 'fr-ca',
  GermanGermany = 'de-de',
  GermanSwitzerland = 'de-ch',
  SpanishMexico = 'es-mx',
  EnglishAustralia = 'en-au',
  EnglishCanada = 'en-ca',
  EnglishUK = 'en-gb',
  EnglishIndia = 'en-in',
  Brazilian = 'br'
}

export enum BaseLocales {
  English = 'en',
  BrazilianPortuguese = 'pt-BR',
  Spanish = 'es',
  French = 'fr',
  German = 'de',
  Russian = 'ru',
  PseudoLocale = 'pseudo-LOCALE',
  Dutch = 'nl',
  Italian = 'it'
}

export type Locales = RegionalLocales | BaseLocales;

export const baseLocalesList = Object.values(BaseLocales).filter(
  value => value !== BaseLocales.PseudoLocale
);

export type LinguiCatalogs = Record<string, any>;
type LinguiCatalogModule =
  | { default?: { messages?: Record<string, any> } | Record<string, any> }
  | { messages?: Record<string, any> };

export const getCatalogMessages = (
  catalogModule: LinguiCatalogModule
): Record<string, any> => {
  if ('messages' in catalogModule && catalogModule.messages) {
    return catalogModule.messages;
  }

  const defaultExport = 'default' in catalogModule ? catalogModule.default : null;
  if (
    defaultExport &&
    typeof defaultExport === 'object' &&
    'messages' in defaultExport &&
    defaultExport.messages
  ) {
    return defaultExport.messages;
  }

  return (defaultExport as Record<string, any>) || {};
};

export const getDefaultCatalogs = async () => {
  const messagesEn = getCatalogMessages(await import('locales/en/messages.js'));
  return {
    [BaseLocales.English]: messagesEn
  };
};
